<template>
  <div v-if="loading || gameList.length > 0" class="slider-box">
    <div class="title">热门游戏推荐</div>
    <div class="swiper-box">
      <el-skeleton :loading="loading" animated>
        <template #default>
          <swiper
            :modules="modules"
            :slides-per-view="4"
            :space-between="20"
            :scrollbar="{ hide: false }"
            :navigation="navigation"
            :autoplay="{ delay: 2500, pauseOnMouseEnter: true }"
          >
            <swiper-slide v-for="game in gameList" :key="game.id">
              <div class="slider-item" @click="openDetail(game)">
                <div class="image-wrapper">
                  <img class="img" :src="game.hotImage" />
                  <!-- 遮罩层 -->
                  <div class="image-overlay">
                    {{ game.description || "好玩的小游戏" }}
                  </div>
                </div>
                <div class="info-box">
                  <div class="titles">{{ game.name || "小游戏" }}</div>
                  <el-button
                    class="button"
                    color="#ffffff"
                    @click.stop="handlePlay(game)"
                  >
                    PLAY
                  </el-button>
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </template>
      </el-skeleton>
      <img
        src="@/assets/images/svg/back.svg"
        class="swiper-button-prev img-btn arr_left"
        alt=""
      />
      <img
        src="@/assets/images/svg/back.svg"
        class="swiper-button-next img-btn arr_right"
        alt=""
        style="transform: rotate(180deg)"
      />
      <div class="custom-pagination1">
        <div
          class="swiper-pagination-bullet1"
          v-for="(item, index) in numSlides"
          :key="index"
          :style="paginationBulletWidth"
        ></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Swiper, SwiperSlide } from "swiper/vue";
import { computed, ref } from "vue";
import { Autoplay, Navigation, Scrollbar } from "swiper/modules";
import { getHotList } from "@/api/game";
import "swiper/css";
import "swiper/css/scrollbar";
import "swiper/css/navigation";
import router from "@/router";

// 轮播
const modules = [Scrollbar, Navigation, Autoplay];
const navigation = ref({
  nextEl: ".swiper-button-next",
  prevEl: ".swiper-button-prev",
});
const numSlides = ref(7);
const paginationBulletWidth = computed(() => {
  return `${100 / (numSlides.value - 4)}%`;
});

// 热门游戏列表
const loading = ref(false);
const gameList = ref([]);
const getGameList = async () => {
  loading.value = true;
  try {
    const res = await getHotList();
    if (res && res.code === 200 && Array.isArray(res.data)) {
      gameList.value = res.data;
    } else {
      gameList.value = [];
    }
  } catch {
    gameList.value = [];
  } finally {
    loading.value = false;
  }
};
getGameList();

// 方法
const handlePlay = (game) => {
  openDetail(game);
};
const openDetail = (game) => {
  router.push(`/_game/detail/${game.id}`);
};
</script>

<style scoped lang="scss">
@import "@/style/rx";

.slider-box {
  margin-top: 89px;

  .title {
    margin-bottom: 58.002px;
    font-size: 32.004px;
    color: var(--ux-text-primary);
    line-height: 41.006px;
    margin-left: 105px;
  }

  .swiper-box {
    margin-top: 23.002px;
    width: 1199.996px;
    height: 457.996px;
    margin: 0 auto;
    padding: 10px 10px;
    position: relative;

    .slider-item {
      width: 280px;
      height: 398px;
      box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.12);
      border-radius: 0 0 0 0;
      padding: 9.996px 9.996px;

      .image-wrapper {
        position: relative;
        overflow: hidden;

        .img {
          width: 260px;
          height: 260px;
          background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0.85) 100%
          );
          border-radius: 0 0 0 0;
        }

        .image-overlay {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          padding: 12px;
          background: rgba(0, 0, 0, 0.7);
          color: white;
          transition: all 0.5s ease-in-out;
          pointer-events: none;
          text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);

          opacity: 0;

          font-family: $font_HanSans;
          font-size: 12px;
          font-weight: 350;
          line-height: 20px;
          text-align: justify;
          display: flex;
          align-items: center;
          letter-spacing: 0;
        }
      }

      &:hover .image-overlay {
        opacity: 1;
      }

      .info-box {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 15px;
        font-size: 21px;
        font-weight: 400;
        color: var(--ux-text-primary);

        .title {
          font-family: Microsoft YaHei UI, Microsoft YaHei UI, serif;
          font-weight: 400;
          font-size: 16px;
          color: var(--ux-text-primary);
          text-align: center;
          font-style: normal;
          text-transform: none;
        }

        .button {
          width: 131px;
          height: 42px;
          border-radius: 12px 12px 12px 12px;
          border: 1px solid var(--ux-line);
          margin-top: 23px;
          font-family: Microsoft YaHei UI, Microsoft YaHei UI, serif;
          font-weight: 400;
          font-size: 14px;
          font-style: normal;
          text-transform: none;
        }
      }
    }

    .img-btn {
      width: 50px;
      height: 50px;
      position: absolute;
    }

    .arr_left {
      left: -50px;
      width: 50px;
      height: 50px;
    }

    .arr_right {
      right: -50px;
      width: 50px;
      height: 50px;
    }

    .swiper {
      height: 410px;
    }

    .custom-pagination1 {
      text-align: center;

      ::v-deep .swiper-pagination-bullet {
        height: 8px;
        width: v-bind(paginationBulletWidth);
        background: var(--ux-surface-muted);
        opacity: 0.5;
        margin: 0;
        border-radius: 5px;
      }

      ::v-deep .swiper-pagination-bullet-active {
        background-color: var(--ux-accent, #00d4ff);
      }
    }
  }
}
</style>
